import Loadable from "app/components/Loadable";
import { lazy } from "react";

const ClientPage = Loadable(lazy(() => import("./ClientPage")));

const accountClientRoutes = [
  { path: "account-clients", element: <ClientPage /> },
];

export default accountClientRoutes;
